export function extractTagIdFromQueryValue(
  queryValue?: string | null
): string | undefined {
  if (!queryValue) return undefined;
  const prefix = 'onlyOneKiTagAverage_';
  return queryValue.includes(prefix)
    ? queryValue.replace(prefix, '')
    : undefined;
}
